import React from 'react';

// 🐨 type props as 'themeprops' + 'valid css props'
const ArrowRight = props => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <title>arrow-right</title>
    <path d="M31.983 16v0c-0.002-0.918-0.397-1.792-1.085-2.4l-14.905-13.119c-0.821-0.672-2.030-0.551-2.702 0.269-0.639 0.78-0.565 1.921 0.169 2.613l11.516 10.133c0.138 0.122 0.15 0.333 0.028 0.471-0.063 0.071-0.153 0.112-0.248 0.112h-22.819c-1.060 0-1.92 0.86-1.92 1.92s0.86 1.92 1.92 1.92h22.815c0.185 0.002 0.333 0.153 0.331 0.338-0.001 0.094-0.041 0.183-0.111 0.246l-11.516 10.133c-0.825 0.666-0.954 1.875-0.287 2.7s1.875 0.953 2.7 0.287c0.042-0.034 0.082-0.069 0.12-0.106l14.908-13.119c0.689-0.608 1.084-1.481 1.087-2.4z"></path>
  </svg>
);

export default ArrowRight;
